<p-panel>
	<app-reactive-form-builder
		#builderRef
		(formChanges)="reactiveFormChanges($event[0], $event[1])"
		(afterSend)="onAfterSend($event)"
		(goBack)="goBack()"
		[form]="form.formFields"
		[dropdownLoadTrigger]="dropdownLoadTrigger"
		[id]="getRegisterId()"
		[dropdownsFinalized]="dropdownsFinalized"
		[request]="request"
		[getRequest]="trabajadoresApi.trabajadoresGET"
	>
	</app-reactive-form-builder>
</p-panel>
